import { Outlet, useNavigate } from "react-router-dom";
import "./admin.style.css";
import React, { lazy, useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from 'react-redux';
import { fetchClientData, resetClientState } from "../../feaures/store/redux/clientSlice"

// Components =======================================================
const Header = lazy(() => import("../../components/Admin/Header/HeaderIndex"))
const Sidebar = lazy(() => import("../../components/Admin/Sidebar/SidebarIndex"))

const AdminDashboard = () => {
    const isLoggedIn = localStorage.getItem("isRichPremisesUserLogedIn")
    const navigate = useNavigate()
    const [isSidebarOpen, setIsSidebarOpen] = useState(false);

    const dispatch = useDispatch()
        const clientStore = useSelector((state) => state.client)
    
        const getClientList = useCallback(() => {
            const data = {
                path: "webUsers"
            }
            dispatch(fetchClientData(data))
        }, [])
    
        useEffect(() => {
            getClientList()
        }, [])
    
        useEffect(() => {
            if (clientStore.fetchClient.success) {
                if (clientStore.fetchClient && clientStore.fetchClient.data) {
                    const link =
                        document.querySelector("link[rel*='icon']") ||
                        document.createElement("link");
                    link.type = "image/x-icon";
                    link.rel = "shortcut icon";
                    link.href = clientStore.fetchClient.data[0].app_favicon;
                    document.getElementsByTagName("head")[0].appendChild(link);
                }
                
                dispatch(resetClientState("fetch"))
            }
        }, [
            clientStore.fetchClient.success
        ])

    const toggleSidebar = () => {
        setIsSidebarOpen(!isSidebarOpen);
    };

    useEffect(() => { 
        if (!isLoggedIn) { navigate("/auth/login") }
    },
    [])

    return  isLoggedIn ? <div className="dashboard-container">
            {/* Sidebar */}
        <Sidebar isSidebarOpen={isSidebarOpen} toggleSidebar={toggleSidebar} />

            {/* Main_ Content */}
            <div className="main-content">
                {/* Header */}
                <Header toggleSidebar={toggleSidebar} />

                {/* Content */}
                <div className="admin-content">
                    <Outlet />
                </div>
            </div>
        </div> : <h1>Please Login first...</h1>
    
};

export default AdminDashboard;
